import { render, staticRenderFns } from "./distributionPage.vue?vue&type=template&id=57110a37&"
import script from "./distributionPage.vue?vue&type=script&lang=js&"
export * from "./distributionPage.vue?vue&type=script&lang=js&"
import style0 from "./distributionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57110a37')) {
      api.createRecord('57110a37', component.options)
    } else {
      api.reload('57110a37', component.options)
    }
    module.hot.accept("./distributionPage.vue?vue&type=template&id=57110a37&", function () {
      api.rerender('57110a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/distributionPage.vue"
export default component.exports